import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const COOKIE_KEY = "mac01_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) setVisible(true);
    const onReset = () => setVisible(true);
    window.addEventListener("mac01:reset-consent", onReset);
    return () => window.removeEventListener("mac01:reset-consent", onReset);
  }, []);

  const choose = (value) => {
    localStorage.setItem(COOKIE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-4 bottom-4 z-50 rounded-lg border border-border bg-popover p-4 shadow-xl sm:left-auto sm:max-w-md"
    >
      <p className="text-sm font-semibold">Respect de votre vie privée</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Ce site utilise uniquement le stockage nécessaire à son fonctionnement et,
        avec votre accord, une mesure d'audience. Consultez notre{" "}
        <Link
          to="/politique-de-confidentialite"
          data-testid="cookie-banner-policy-link"
          className="text-primary underline-offset-4 hover:underline"
        >
          politique de confidentialité
        </Link>
        .
      </p>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => choose("accepted")} data-testid="cookie-accept-button">
          Accepter
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={() => choose("refused")}
          data-testid="cookie-refuse-button"
        >
          Refuser
        </Button>
      </div>
    </div>
  );
};
